import * as React from "react";
import { LocalizedComponentProps } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkPlaceholderCard } from "uitk-react-cards";
import { FlexComponent, FlexComponentProps, ModuleDefinition } from "typings/flexFramework/FlexComponent";

export interface BlossomComponentsProps extends LocalizedComponentProps {
  context: ExtendedContextStore;
  logger?: Logger;
  blossomComponent?: BlossomComponent;
  flexComponents?: FlexComponent[];
  moduleDefinitions?: ModuleDefinition[];
}

interface GridViewProps extends FlexComponentProps {
  moduleDefinition?: ModuleDefinition;
  title: string;
  innerTitle: string;
  UCIs: string[];
}

interface GridItemProps {
  centerStage?: boolean;
  uci: string;
}

interface TitleProps {
  title: string;
}

const headingConfig: UitkHeadingProps = { tag: "h2", size: 3 };
const Title: React.FC<TitleProps> = ({ title }) => (
  <UitkSpacing padding={{ blockend: "three" }}>
    <UitkHeading {...headingConfig}>{title}</UitkHeading>
  </UitkSpacing>
);

const MarqueeGridItem: React.FC<GridItemProps> = ({ centerStage, uci }) => {
  return (
    <UitkLayoutGridItem
      className={`meso-native-card-${centerStage ? "center-stage" : "small"}`}
      rowSpan={centerStage ? 2 : 1}
      colSpan={centerStage ? { large: 8, small: 12 } : { large: 4, small: 12 }}
    >
      <div>
        <meso-native uci={uci} nativetype="marquee" isfluid adslot={uci} data-testid="meso-native" />
        <UitkPlaceholderCard />
      </div>
    </UitkLayoutGridItem>
  );
};

export const MarqueeGridView: React.FC<GridViewProps> = ({ title, innerTitle, UCIs }) => {
  return (
    <>
      {title && <Title title={title} />}
      {innerTitle && <Title title={innerTitle} />}
      <UitkLayoutGrid columns={12} rows={2} space="three">
        <MarqueeGridItem uci={UCIs[0]} centerStage />
        <MarqueeGridItem uci={UCIs[1]} />
        <MarqueeGridItem uci={UCIs[2]} />
      </UitkLayoutGrid>
    </>
  );
};
